import React, { useState } from 'react'
import { Divider, Popconfirm, Button, Card, Tooltip, Icon, Table, Input, Select, Row, Col } from 'antd'
import moment from 'moment'
import { compose, graphql, withApollo } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import HeroPOView from './HeroPOView'
import UpdateDetail from './UpdateDetail'
import UpdateHeroPo from './UpdateHeroPo'
import _ from 'lodash'
import {
  fetchHeroSellingList,
  updatePODetail,
  updateHeroPo,
  deletePO
} from '../../modules/heroGroupSelling'

const PO_TYPE_OPTIONS = [
  { value: 'Free to Sell', label: 'ส่งปกติ' },
  { value: 'Reserve', label: 'รวมกลุ่มส่ง' },
  { value: 'Confirm to Sent', label: 'ยืนยันก่อนส่ง' }
]

const PO_STATUS_OPTIONS = ['ACTIVE', 'CONFIRM_PENDING', 'CANCEL', 'DELETE', 'TIMEOUT']

const HeroPO = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [visibleDetail, setVisibleDetail] = useState(false)
  const [visibleUpdate, setVisibleUpdate] = useState(false)
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(20)
  const [filters, setFilters] = useState({})

  const { heroSellingList, heroSellingTotal, isLoading } = useSelector(
    (state) => ({
      heroSellingList: state.heroGroupSelling.heroSellingList,
      heroSellingTotal: state.heroGroupSelling.heroSellingTotal,
      isLoading: state.heroGroupSelling.isLoading
    }),
    []
  )

  async function fetch(p = page, s = pageSize, f = filters) {
    await dispatch(fetchHeroSellingList(p, s, f))
  }

  const onSearch = () => {
    setPage(0)
    fetch(0, pageSize, filters)
  }

  const onReset = () => {
    const empty = {}
    setFilters(empty)
    setPage(0)
    fetch(0, pageSize, empty)
  }

  useDeepEffect(() => {
    fetch()
  }, [])

  const columns = [

    {
      title: 'วันที่ราคามีผล',
      width: 150,
      render: (text, record) => (
        <span>{record.datePriceStart ? moment(record.datePriceStart).format('DD/MM/YYYY') : ''} - {record.datePriceEnd ? moment(record.datePriceEnd).format('DD/MM/YYYY') : ''}</span>
      )
    },
    {
      title: 'วัสดุที่รับ',
      dataIndex: 'materialName',
      key: 'materialName',
      render: (materialName) => <span>{materialName}</span>
    },
    {
      title: 'ผู้ประกาศ',
      key: 'heroName',
      dataIndex: 'heroName',
      render: (heroName) => <span>{heroName}</span>
    },
    {
      title: 'ยอดนับซื้อทั้งหมด',
      key: 'quota',
      dataIndex: 'quota',
      width: 120,
      render: (quota) => <span>{quota}</span>
    },
    {
      title: 'รับขั้นต่ำ',
      key: 'minimum',
      dataIndex: 'minimum',
      width: 100,
      render: (minimum) => <span>{minimum}</span>
    },
    {
      title: 'ราคา/หน่วย',
      key: 'price',
      dataIndex: 'price',
      width: 100,
      render: (price) => <span>{price}</span>
    },
    {
      title: 'ประเภท',
      key: 'type',
      dataIndex: 'type',
      width: 120,
      render: (type) => { const opt = PO_TYPE_OPTIONS.find((o) => o.value === type); return <span>{opt ? opt.label : type}</span> }
    },
    {
      title: 'รายละเอียด',
      key: 'detail',
      dataIndex: 'detail',
      onCell: () => {
        return {
          style: {
            whiteSpace: 'nowrap',
            maxWidth: 150,
          }
        }
      },
      render: (detail, record) =>
        <Tooltip title={detail}>
          <div style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
            <span>
              {detail ? <a onClick={(e) => onClickDetail(e, record)}>แก้ไขข้อมูล &nbsp; <Icon type="edit" /></a> :
                <a onClick={(e) => onClickDetail(e, record)}>เพิ่มข้อมูล &nbsp; <Icon type="edit" /></a>}
            </span>
          </div>
        </Tooltip>

    },
    {
      title: 'สถานะ',
      key: 'status',
      dataIndex: 'status',
      width: 180,
      render: (status) => <span>{status}</span>
    },
    {
      title: 'Action',
      key: 'action',
      width: 130,
      render: (text, record) => (
        <span style={{ whiteSpace: 'nowrap' }}>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="eye"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
          <Divider type="vertical" />
          <Button
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => { e.currentTarget.blur(); onClickUpdate(e, record) }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }

  const onCloseModal = async () => {
    await fetch()
    await setVisible(false)
  }

  const onTableChange = (pagination) => {
    const newPage = pagination.pageSize !== pageSize ? 0 : pagination.current - 1
    const newSize = pagination.pageSize
    setPage(newPage)
    setPageSize(newSize)
    fetch(newPage, newSize, filters)
  }


  const onClickDetail = (e, record) => {
    e.preventDefault()
    setFormData(record)
    setVisibleDetail(true)
  }

  const onCloseModalDetail = async () => {
    await setVisibleDetail(false)
    await fetch()
  }

  const onOkDetail = async (data) => {
    await dispatch(updatePODetail(data))
    await fetch()
    await setVisibleDetail(false)
    await setFormData({})
  }

  const onClickUpdate = (e, record) => {
    e.preventDefault()
    setFormData(record)
    setVisibleUpdate(true)
  }

  const onCloseModalUpdate = () => {
    setVisibleUpdate(false)
    setFormData({})
  }

  const onOkUpdate = async (data) => {
    await dispatch(updateHeroPo(data))
    await fetch()
    setVisibleUpdate(false)
    setFormData({})
  }

  const onDelete = async (id) => {
    await dispatch(deletePO(id))
    const newTotal = heroSellingTotal - 1
    const maxPage = Math.max(0, Math.ceil(newTotal / pageSize) - 1)
    const safePage = Math.min(page, maxPage)
    setPage(safePage)
    fetch(safePage, pageSize, filters)
  }

  return (
    <div>
      {(!visible) ?
        <Card title="รายการรับซื้อ (PO)">
          <Row gutter={[8, 8]} style={{ marginBottom: 8 }}>
            <Col xs={24} sm={12} md={6}>
              <Input
                placeholder="ชื่อวัสดุ"
                value={filters.materialName || ''}
                onChange={(e) => setFilters({ ...filters, materialName: e.target.value })}
                onPressEnter={onSearch}
              />
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Input
                placeholder="ชื่อผู้ประกาศ"
                value={filters.heroName || ''}
                onChange={(e) => setFilters({ ...filters, heroName: e.target.value })}
                onPressEnter={onSearch}
              />
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Select
                placeholder="ประเภท"
                allowClear
                style={{ width: '100%' }}
                value={filters.type || undefined}
                onChange={(val) => setFilters({ ...filters, type: val })}
              >
                {PO_TYPE_OPTIONS.map((opt) => (
                  <Select.Option key={opt.value} value={opt.value}>{opt.label}</Select.Option>
                ))}
              </Select>
            </Col>
            <Col xs={12} sm={12} md={6}>
              <Select
                placeholder="สถานะ"
                allowClear
                style={{ width: '100%' }}
                value={filters.status || undefined}
                onChange={(val) => setFilters({ ...filters, status: val })}
              >
                {PO_STATUS_OPTIONS.map((s) => (
                  <Select.Option key={s} value={s}>{s}</Select.Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row style={{ marginBottom: 16 }}>
            <Col>
              <Button type="primary" onClick={onSearch} style={{ marginRight: 8 }}>ค้นหา</Button>
              <Button onClick={onReset}>รีเซต</Button>
            </Col>
          </Row>
          <Table
            scroll={{ x: 1300 }}
            loading={isLoading}
            bordered
            dataSource={heroSellingList}
            columns={columns}
            rowKey={(record) => {
              return record.id
            }}
            pagination={{
              current: page + 1,
              pageSize: pageSize,
              total: heroSellingTotal
            }}
            onChange={onTableChange}
          />
          <UpdateDetail
            visible={visibleDetail}
            onOk={onOkDetail}
            onCancel={onCloseModalDetail}
            formData={formData}
          />
          <UpdateHeroPo
            visible={visibleUpdate}
            onOk={onOkUpdate}
            onCancel={onCloseModalUpdate}
            formData={formData}
          />
        </Card>
        :
        <HeroPOView
          visible={visible}
          formData={formData}
          onCancel={onCloseModal}
        />}
    </div>
  )
}

export default compose(
  withApollo,
)(HeroPO)
